<script lang="ts">
  import { Copy, CheckSmall } from "../icons/index.js";

  interface Props {
    text: string;
  }

  let { text }: Props = $props();

  let showSuccess = $state(false);

  function copyToClipboard() {
    navigator.clipboard.writeText(text);

    showSuccess = true;

    setTimeout(() => {
      showSuccess = false;
    }, 1000);
  }
</script>

<button
  onclick={copyToClipboard}
  aria-label="copy to clipboard"
  type="button"
  class="rounded-xs text-subtle focus-ring transition-colors duration-100 hover:text-foreground-primary"
>
  {#if showSuccess}
    <CheckSmall aria-hidden="true" />
  {:else}
    <Copy aria-hidden="true" />
  {/if}
</button>
